import React, { useState } from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import './style.css'
import Buttons from 'components/componentsmall/button'
import Title from 'components/componentsmall/title'
import TestimonialJson from 'json/testimonial'

export default function Testimonial({ sliders }) {
    const [current, setCurrent] = useState(0);
    const lengts = sliders.length;


    const nextSlide = _ => {
        setCurrent(current === lengts - 1 ? 0 : current + 1)
    }

    const prevSlide = _ => {
        setCurrent(current === 0 ? lengts  - 1 : current - 1)
    }

    if (!Array.isArray(sliders) || sliders.length <= 0) {
        return null
    }

    return (
        <Container className="home-testimonial">
          <Title judul="Testimoni" />     
            <img className="prev" src="asset/home/icons/arr-testimony-left.svg" onClick={prevSlide} alt="testimony-left" /> 
            <img className="next" src="asset/home/icons/arr-testimony-right.svg" onClick={nextSlide} alt="testimony-right" />         
             {
                TestimonialJson.map((data, i) => {
                    return (
                          <Row className="justify-content-md-center" key={i}>
                          {
                              i === current && (
                                <>
                                <Col md={4}>
                                    <div className="gambar-testi">
                                        <img src={`asset/home/${data.image}`} alt={data.alt} />
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <div className="content-testi">
                                        <p>{data.text}</p>
                                        <div className="text-muted">
                                            {data.txt_muted}
                                        </div>
                                    </div>
                                </Col>
                                </>
                              )
                          }
                            
                          </Row>
                            )
                        })
                    } 
           <Buttons to="/signup" btn_tombol="btn-testimony" tombol="Daftar Sekarang" />
        </Container>
    )
}
